module.exports = "<div _ngcontent-c3=\"\" class=\"fixed-top\" style=\"\n    height: 100vh;\n    display: flex;\n    align-items: center;\n    text-align: center;\n    justify-content: center;\n    background-color: #ffffff;\n\">\n\t<h1 _ngcontent-c3=\"\" class=\"fa fa-clock-o\" style=\"\n    display: inline-block;\n    text-align: center;\n    font-size: 10em;\n\"></h1>\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/waiting/waiting.component.html
// module id = ./src/app/components/waiting/waiting.component.html
// module chunks = main